import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'banner-unsubscribed',
  styleUrl: 'banner-unsubscribed.css',
  shadow: false,
})
export class BannerUnsubscribed {
  @Prop() showDesktop: boolean = false;

  render() {
    const bannerUnsubscribedClass = {
      'flex w-full my-auto justify-center items-center text-center text-clrs-white ': true,
      'text-base py-20': !this.showDesktop,
      'text-lg leading-none py-7': this.showDesktop,
    };
    return (
      <Host class={bannerUnsubscribedClass}>
        This subscriber no longer participates in the
        <br />
        Kelley Blue Book&reg; Instant Cash Offer
      </Host>
    );
  }
}
